import { useCallback, useRef, useState } from 'react'
import { Transition } from 'react-transition-group'
import type { TransitionStatus } from 'react-transition-group'

type TransitionStyle = Record<TransitionStatus, Record<string, unknown>>

export const useFadeTransition = (duration: number) => {
  const [inProp, setInProp] = useState(false)
  const nodeRef = useRef<HTMLDivElement>(null)

  /**
   * トランジションが発生してから関数を実行させる
   */
  const transitionFn = (fn: () => unknown) => {
    setInProp(true)

    setTimeout(() => {
      fn()
    }, duration)
  }

  const render = useCallback(
    (children: JSX.Element) => {
      const defaultStyle = {
        transition: `opacity ${duration}ms cubic-bezier(0.55, 0.085, 0.68, 0.53)`,
        opacity: 1,
      }

      const transitionStyle: TransitionStyle = {
        entering: {
          opacity: 0,
        },
        entered: {
          opacity: 1,
        },
        exiting: {
          opacity: 1,
        },
        exited: {
          opacity: 1,
        },
        unmounted: {
          opacity: 0,
        },
      }

      return (
        <Transition
          nodeRef={nodeRef}
          in={inProp}
          timeout={duration}
          onEntered={() => setInProp(false)}
        >
          {(state) => (
            <div
              ref={nodeRef}
              style={{ ...defaultStyle, ...transitionStyle[state] }}
            >
              {children}
            </div>
          )}
        </Transition>
      )
    },
    [duration, inProp, nodeRef]
  )

  return { render, transitionFn }
}
